module.exports = __webpack_public_path__ + "static/img/Dane-Gagai.0bbe85d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dane-Gagai.jpg
// module id = 1/qe
// module chunks = 0